import React from 'react';
import { AuthProvider } from './AuthContext';
import { CommunityProvider } from './CommunityContext';
import { AssetProvider } from './AssetContext';
import { NotificationProvider } from './NotificationContext';
import { CalendarProvider } from './CalendarContext';
import { AudioAnalysisProvider } from './AudioAnalysisContext';

const AppProvider = ({ children }) => {
  return (
    <AuthProvider>
      <NotificationProvider>
        <AudioAnalysisProvider>
          <CommunityProvider>
            <AssetProvider>
              <CalendarProvider>
                {children}
              </CalendarProvider>
            </AssetProvider>
          </CommunityProvider>
        </AudioAnalysisProvider>
      </NotificationProvider>
    </AuthProvider>
  );
};

export default AppProvider;
